import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { AssetLocation, Booking, IKmosGetManualAllocationLanesParameters } from "../../../logic/api";
import { useTranslation } from "react-i18next";
import { Fragment, useContext, useEffect, useState } from "react";
import propTypes from "prop-types";
import { Button } from "@mui/material";
import { EditableGroupContext } from "../../../components/editable/EditableGroup/EditableGroup";
import VehicleAllocationLaneSelector from "./VehicleAllocationLaneSelector";

const VehicleAllocationPickerDialog: React.FunctionComponent<{
    show: boolean;
    booking?: Booking | null;
    onChange: (location: AssetLocation | null) => void,
    onCancel: () => void,
}> = (props) => {
    const state = useContext(EditableGroupContext);
    const booking = props.booking ?? state?.data as Booking | null;

    const getKmosLaneParams = (): IKmosGetManualAllocationLanesParameters | null => {
        if (booking?.expectedReturnDate == null) {
            return null;
        }
        return {
            returnDate: booking?.expectedReturnDate || "",
            excludeLaneId: booking?.vehicle?.allocatedLane?.id,
        };
    };

    const { t } = useTranslation();
    const [selectedTargetLocation, setSelectedTargetLocation] = useState<AssetLocation | null>(null);
    const [laneSelectorParams, setLaneSelectorParams] =
        useState<IKmosGetManualAllocationLanesParameters | null>(getKmosLaneParams());

    useEffect(() => {
        if (props.show == true) {
            setLaneSelectorParams(getKmosLaneParams());
            setSelectedTargetLocation(null);
        }
    }, [booking, props.show]);

    return <Dialog open={props.show} maxWidth={"sm"} fullWidth={true}>
        <DialogTitle>{t("booking.labels.newAllocation")}</DialogTitle>
        <DialogContent>
            <div style={{ padding: 20, textAlign: "center" }}>
                <div style={{ display: "inline-block", marginTop: 100, marginBottom: 100 }}>
                    {laneSelectorParams != null &&
                        <Fragment>
                            <VehicleAllocationLaneSelector
                                params={laneSelectorParams}
                                value={selectedTargetLocation || null}
                                onChange={(value) => {
                                    setSelectedTargetLocation(value);
                                }}
                                label={t("kmos.labels.selectLane")}
                            ></VehicleAllocationLaneSelector>

                            <div style={{ height: 50 }}></div>
                            <Button disabled={selectedTargetLocation == null} variant="contained" color="secondary" onClick={() => {
                                props.onChange(selectedTargetLocation);
                            }}>
                                {t("booking.labels.allocateButton")}
                            </Button>
                        </Fragment>
                    }
                </div>
            </div>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => props.onCancel()}>{t("general.cancel")}</Button>

        </DialogActions>
    </Dialog>
};
VehicleAllocationPickerDialog.propTypes = {
    show: propTypes.bool.isRequired,
    booking: propTypes.any,
    onChange: propTypes.func.isRequired,
    onCancel: propTypes.func.isRequired,
}
export default VehicleAllocationPickerDialog;